import React from 'react';
import {Link} from 'react-router-dom';
import {Linkedin,Instagram,Youtube} from 'lucide-react';
import {company} from '../data/company';

const cols=[
  {h:'Menü',links:[['Anasayfa','/'],['Kurumsal Seyahat Yönetimi','/kurumsal-seyahat-yonetimi'],['Teknolojimiz','/plaza-flow'],['Plazette','/plazette'],['Hakkımızda','/hakkimizda'],['İletişim','/iletisim']]},
  {h:'Hizmet Alanlarımız',links:[['Uçak Bileti','/ucak-bileti'],['Konaklama','/otel-konaklama'],['Vize Hizmetleri','/vize-hizmetleri'],['Araç Kiralama','/arac-kiralama'],['Etkinlik / MICE','/etkinlik-organizasyon'],['VIP Transfer','/vip-transfer']]}
];

const socials=[
  {Icon:Linkedin,href:company.social.linkedin,label:'LinkedIn'},
  {Icon:Instagram,href:company.social.instagram,label:'Instagram'},
  {Icon:Youtube,href:company.social.youtube,label:'YouTube'}
];

export default function Footer(){
  return <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        <div className="footer-brand">
          <img src="/assets/plaza-logo.png" alt="Plaza Turizm" width="399" height="97"/>
          <div className="footer-contact">
            <p><a href={company.phoneHref} style={{padding:0,display:'inline'}}><strong>{company.phone}</strong></a></p>
            <p><a href={`mailto:${company.email}`} style={{padding:0,display:'inline'}}>{company.email}</a></p>
            <p style={{marginTop:10}}>{company.address.line}<br/>{company.address.zipCity}</p>
          </div>
          <div className="footer-social">
            {socials.map(({Icon,href,label})=>(
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={`footer-social-${label.toLowerCase()}`}><Icon size={19} strokeWidth={2}/></a>
            ))}
          </div>
        </div>
        {cols.map(c=>(
          <div key={c.h}>
            <p className="footer-h">{c.h}</p>
            {c.links.map(([label,to])=><Link key={label+to} to={to}>{label}</Link>)}
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} {company.name}.<br/>{company.legalTagline}</span>
        <span>{company.domain}</span>
      </div>
    </div>
  </footer>;
}
